export const TRADEMARK_CHECK = {
  id: 'demo-skl-trademark-check',
  title: 'Trademark similarity check',
  description:
    'Checks a proposed name against advertised and registered marks and rates how risky it looks, with the reasons.',
  apps: ['Web research'],
  usedCount: 6,
  lastUsedMinutesAgo: 3 * 24 * 60 + 300,
  instructions: `**To check a mark:**

1. Search the IP-India public register and the latest trademark journals for the name and close variants (spelling, phonetics, translation).
2. Keep matches in the same or neighbouring classes (Nice classes 9, 35, 42 by default).
3. For each match give: mark, application number, class, status, and owner.
4. Rate the overall risk **Low / Medium / High** and explain the deciding factors.

**Always** note that this is a screening, not legal advice, and link every record you cite.`,
  examples: ['Is “DataPulse” safe to file in class 42?', 'Check “ObserveIQ” against Indian trademarks'],
}
